import { DeviceResult } from "../types";
import useRequest, { Fetch, RequestResult } from "./useRequest";

export default function useDevice(
  id: number,
  params?: Record<string, unknown>,
): [RequestResult<DeviceResult>, Fetch] {
  return useRequest<DeviceResult, any>(`/device/${id}/`, params);
}
